import { Component, OnInit } from '@angular/core';
import { fadeInAnimation } from '../animations/index';
import { CtlService }           from '../services';
import { Group, Organisation }  from '../models/';

@Component({
  selector: 'export-component',
  templateUrl: '../templates/export.component.html'
})

export class ExportComponent implements OnInit {

  organisations: Organisation[] = null;
  selectedOrganisation: Organisation;

  loading: boolean = false;

  groups: Group[] = null;
  selectedGroup: Group;

  constructor(private ctlService: CtlService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.ctlService.getOrganisations()
      .then(organisations => {
        this.organisations = organisations;
        this.loading = false;
        });
  }

  selectOrganisation(selected: any): void {
    this.groups = null;
    if(selected.id) {
      this.loading = true;
      this.ctlService.getGroups(this.selectedOrganisation)
        .then(groups => {
          this.groups = (groups.length <= 0) ? null : groups;
          this.loading = false;
        });
    }
  }

  unselectOrganisation(): void {
    this.selectedGroup = null;
    this.groups = null;
  }

  fetchExport(): void {
    this.loading = true;
    this.ctlService.getExport(this.selectedOrganisation, this.selectedGroup).then(() => { this.loading = false });
  }

  fetchGatewayExport(): void {
    this.loading = true;
    this.ctlService.getGatewayExport(this.selectedOrganisation, this.selectedGroup).then(() => { this.loading = false });
  }

  autocompleteListFormatter(data: any): string {
    return data.name;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/export.component.ts